import { render, staticRenderFns } from "./b-select-checkbox.vue?vue&type=template&id=1d321e31&scoped=true"
import script from "./b-select-checkbox.vue?vue&type=script&lang=js"
export * from "./b-select-checkbox.vue?vue&type=script&lang=js"
import style0 from "./b-select-checkbox.vue?vue&type=style&index=0&id=1d321e31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d321e31",
  null
  
)

export default component.exports